import React from "react";
import { XCircle } from "lucide-react";
import { PageContainer } from "@/components/layout/PageContainer";

export const RecordNotFound = () => {
  return (
    <PageContainer>
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center space-y-4 animate-in fade-in zoom-in duration-500 mt-20">
        <div className="bg-destructive/10 p-6 rounded-full text-destructive shadow-inner">
          <XCircle className="h-16 w-16" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">
            Record not found
          </h1>
          <p className="text-muted-foreground max-w-md mx-auto">
            The record you are looking for doesn't exist or has been removed.
          </p>
        </div>
      </div>
    </PageContainer>
  );
};

export default RecordNotFound;
